<template>
  <div class="course-card" @click="handlerJumpPage">
    <div class="course-card__img">
      <CardImg :url="url" />
    </div>
    <div class="course-card__main">
      <h6 class="course-card__title">{{data.courseName || ''}}</h6>
      <div class="course-card__title--minor">{{data.teacherName || ''}}</div>
      <div class="course-card__main__btm">
        <MoneyTag :amount="data.price || 0" />
        <div class="people-num">{{data.learningNum || 0}}人在学</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import CardImg from '@/components/card/CardImg.vue';
import MoneyTag from '@/components/card/MoneyTag.vue';
import { resizeAlcdnUrl } from '@/common/js/utils';
import router from '@/router';

export default {
  components: {
    CardImg,
    MoneyTag,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          courseName: '', // 课程名
          cover: '', // 封面图
          id: 0,
          learningNum: 0, // 学习人数
          oldUrl: '', // 旧的训练营跳转链接
          price: 0,
          status: 0, // 0 旧训练营，1 新
          teacherName: ''
        };
      }
    }
  },
  setup(props) {
    const url = ref('');

    if (props.data.cover) {
      url.value = resizeAlcdnUrl(props.data.cover, 68);
    }

    const handlerJumpPage = () => {
      if (props.data.status === 0) {
        window.location.href = props.data.oldUrl;
      } else {
        router.push(`/camp/${props.data.id}`);
      }
    };

    return {
      url,
      handlerJumpPage
    };
  }
};
</script>

<style lang="stylus" scoped>
.course-card {
  display: flex;
  padding: 16px 0;

  .course-card__img {
    width: 68px;
    height: 85px;
  }

  .course-card__main {
    position: relative;
    margin-left: 12px;
    flex: 1 1 0%;

    .course-card__title {
      word-break: break-all;
      display: -webkit-box;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 15px;
      font-weight: 500;
      color: #191919;
      line-height: 20px;
    }

    .course-card__title--minor {
      position: absolute;
      bottom: 28px;
      left: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width 100%
      font-size: 11px;
      color: #999;
    }

    .course-card__main__btm {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: flex-end;

      .people-num {
        margin-left: 8px;
        font-size: 11px;
        color: #999;
      }
    }
  }
}
</style>
